import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  email = '';
  constructor(
    private modalController: ModalController,
    public globals: GlobalVariable,
    private alertController: AlertController,
    public server: ServerService
  ) {}

  ngOnInit() {}
  close() {
    this.modalController.dismiss();
  }

  submit() {
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (this.email.match(validRegex)) {
      this.globals.Loader();
      this.server.customerForgotPassword(this.email).subscribe(
        (res) => {
          this.globals.loading.dismiss();
          console.log(res);
          if (res.status === 'error') {
            this.globals.presentToast(
              res.description,
              2000,
              'middle',
              'danger'
            );
          } else {
            this.confirm();
          }
        },
        (err) => {
          this.globals.loading.dismiss();
          this.globals.presentToast('network error.');
        }
      );
    } else {
      this.globals.presentToast(
        'Please enter a valid email to continue',
        1000,
        'middle',
        'danger'
      );
    }
  }

  async confirm() {
    const alert = await this.alertController.create({
      header: 'Check your Email',
      message:
        "we've sent you an email with temporary password for sign in. You can change your password from app settings",
      buttons: [
        {
          text: 'Okay',
          handler: () => {
            this.close();
            // console.log('Confirm Okay');
          },
        },
      ],
    });

    await alert.present();
  }
}
